export const REDUCER_NAME = 'csv-upload'



// WEBPACK FOOTER //
// ./src/modules/foil/state/overview/csv-upload/const.js